module.exports = __webpack_public_path__ + "img/水力.16acbd70.jpg";